import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="border-t border-white/5 bg-slate-950" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <Logo className="h-8 w-8" />
              <span className="font-heading font-bold text-xl text-white">Bit Buddies</span>
            </Link>
            <p className="text-slate-400 text-sm max-w-md">
              Where innovative software ideas meet visionary investors. 
              Discover, acquire, or invest in the next breakthrough technology.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/ideas" className="text-slate-400 hover:text-cyan-400 text-sm transition-colors" data-testid="footer-link-ideas">
                  Browse Ideas
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>MDH@BitBuddies.online</li>
              <li>Addison, TX</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Bit Buddies. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/terms" className="text-slate-500 hover:text-slate-300 text-sm transition-colors" data-testid="footer-terms">
              Terms of Service
            </Link>
            <Link to="/privacy" className="text-slate-500 hover:text-slate-300 text-sm transition-colors" data-testid="footer-privacy">
              Privacy Policy
            </Link>
            <Link to="/liability" className="text-slate-500 hover:text-slate-300 text-sm transition-colors" data-testid="footer-liability">
              Release of Liability
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
